module.exports = __webpack_public_path__ + "static/img/ewm-cd.b23a500.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ewm-cd.png
// module id = OelL
// module chunks = 1